export const GET_VEHICLES = "GET_VEHICLES";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const GET_COMPANY = "GET_COMPANY";

